/**
 * Created by Claude on 21/01/2026.
 * 修改设备配置成功后的提示弹窗
 */
import React from 'react';
import { Modal } from 'antd';
import i18n from 'i18next';
import Styles from '../config/css/EditConfigTipModal.module.scss';

function DeviceConfigTipModal({ visible, onOk, configName }) {
  return (
    <Modal
      width={480}
      title={i18n.t('device_config_modified_title')}
      visible={visible}
      onCancel={onOk}
      onOk={onOk}
      okText={i18n.t('i_known')}
      cancelButtonProps={{ style: { display: 'none' } }}
    >
      <div className={Styles.content}>
        <div className={Styles.attentionSection}>
          <span className={Styles.attentionLabel}>{i18n.t('device_config_attention_label')}</span>
          <span className={Styles.warningText}>
            {i18n.t('device_config_warning')}
          </span>
        </div>

        <div className={Styles.instructionList}>
          <div className={Styles.instructionItem}>
            <span className={Styles.stepLabel}>
              {i18n.t('device_config_wifi_step_label')}
            </span>
            <span className={Styles.stepText}>
              {i18n.t('device_config_wifi_step_text')}
            </span>
          </div>

          <div className={Styles.instructionItem}>
            <span className={Styles.stepLabel}>
              {i18n.t('device_config_nb_iot_step_label')}
            </span>
            <span className={Styles.stepText}>
              {i18n.t('device_config_nb_iot_step_text')}
            </span>
          </div>
        </div>
      </div>
    </Modal>
  );
}

export default DeviceConfigTipModal;
